
import { Component, Vue } from 'vue-property-decorator'
import FillgridFilters from '@/components/fillgrid/fillgrid-filters.vue'
import FillgridViews from '@/components/fillgrid/fillgrid-views.vue'
import LocationMap from '@/components/maps/LocationMap.vue'
import InputFormValue from '@/components/forms/input-form-value.vue'
import fillgridData from '@/data/fillgrid'

@Component({
  components: {
    FillgridFilters,
    FillgridViews,
    LocationMap,
    InputFormValue
  }
})
export default class FillgridTest extends Vue {
  templateId: any = 0

  filters: any = {}
  items: any[] = []
  selectedItems: string[] = []
  toggleAll = false
  loadingData = false
  leftSidebarCollapsed = false
  columnsToShow: any[] = []
  showHistory = false
  showImagesActive = false

  // Mock data
  columns: any[] = []

  /** Mock users */
  users = ['bcm6', 'sonm4', 'dgom3', 'tampsm16', 'vmexm6']

  mediaViewerTypes = {
    IMAGE: 1,
    PDF: 2,
    MAP: 3
  }

  mediaViewer = {
    active: false,
    type: 0,
    src: {}
  }

  /** Update operations */
  assignationUser = ''
  activeDeleteRows = false
  activeUpdateMultipleRows = false
  fieldToUpdate = ''
  columnsFiltered: any[] = []
  fieldsListToUpdate: any[] = []
  downloadEmail = ''

  created () {
    this.searchData()

    this.columnsFiltered = this.columns
  }

  backToTemplates () {
    this.$router.push({ name: 'fillgridTemplate' })
  }

  showImages () {
    this.showImagesActive = !this.showImagesActive
  }

  /** Items selection */

  toggleAllItemsSelection (checked: boolean) {
    this.toggleAll = checked
    if (checked) {
      this.selectedItems = this.items.reduce((arr: any[], it: any) => {
        return arr.concat(it.ID)
      }, [])
    } else {
      this.selectedItems = []
    }
  }

  selectItem (checked: boolean, item: any) {
    const index = this.selectedItems.indexOf(item.ID)

    if (checked && index === -1) {
      this.selectedItems.push(item.ID)
    }
    if (!checked && index > -1) {
      this.selectedItems.splice(index, 1)
    }
  }

  isItemSelected (itemId: any) {
    return this.selectedItems.indexOf(itemId) > -1
  }

  /** Fetch data */

  searchData (filters?: any) {
    if (this.loadingData) return
    if (filters) this.filters = filters
    this.loadingData = true
    this.columns = fillgridData.columns
    this.items = fillgridData.data
    setTimeout(() => {
      this.loadingData = false
    }, 1000)
  }

  applyView (selection: any[]) {
    this.columnsToShow = JSON.parse(JSON.stringify(selection))
  }

  isColumnVisible (columnName: string) {
    return !this.columnsToShow.length || columnName === 'ID' || this.columnsToShow.indexOf(columnName) > -1
  }

  /** Media viewer */
  showMediaViewer (type: number, src: any) {
    let route = ''
    switch (type) {
      case this.mediaViewerTypes.MAP:
        route = this.$router.resolve({ name: 'mediapreview', params: { type: 'map' }, query: { lat: src[0], lng: src[1] } }).href
        break
      case this.mediaViewerTypes.IMAGE:
        route = this.$router.resolve({ name: 'mediapreview', params: { type: 'img' }, query: { src: src } }).href
        break
      default:
        this.mediaViewer.src = src
    }
    if (route) {
      window.open(route, '_blank')
    }
  }

  /** Updates */

  openAssignUser () {
    if (this.validateSelection()) {
      this.assignationUser = ''
      this.$bvModal.show('assign-user-modal')
    }
  }

  saveAssignationUser () {
    if (this.assignationUser) {
      // Make the ajax request
      this.items.forEach(it => {
        if (this.selectedItems.indexOf(it.ID) > -1) { it.USER = this.assignationUser }
      })
      this.$bvModal.hide('assign-user-modal')
      this.$bvToast.toast('El usuario ha sido asignado correctamente', {
        title: 'Listo',
        autoHideDelay: 4000
      })
    }
  }

  /** DELETE */

  openDeleteRows () {
    if (this.validateSelection()) {
      this.activeDeleteRows = false
      this.$bvModal.show('delete-rows-modal')
    }
  }

  deleteRows () {
    // Make the ajax request
    this.selectedItems = []
    this.$bvModal.hide('delete-rows-modal')
    this.$bvToast.toast('Los registros han sido borrados correctamente', {
      title: 'Listo',
      autoHideDelay: 4000
    })
    this.searchData()
  }

  /** UPDATES */

  openUpdatesMultiple () {
    if (this.validateSelection()) {
      this.fieldsListToUpdate = []
      this.activeUpdateMultipleRows = false
      this.$bvModal.show('updates-multiple-modal')
    }
  }

  addFieldToUpdate (field: string) {
    const columnConfig = this.columns.find(it => it.name === field)
    this.fieldsListToUpdate.push({ label: columnConfig.label, type: columnConfig.type })
    this.fieldToUpdate = ''
    setTimeout(() => {
      const id = 'input-update-' + (this.fieldsListToUpdate.length - 1)
      const element = document.getElementById(id)
      if (element) element.focus()
    }, 500)
  }

  deleteFieldToUpdate (index: number) {
    this.fieldsListToUpdate.splice(index, 1)
  }

  applyUpdatesMultiple () {
    // Make the ajax request
    if (!this.validFields()) {
      this.$bvToast.toast('Algunos valores ingresados no son correctos', {
        title: 'Validación',
        autoHideDelay: 3500
      })
      return false
    }
    this.$bvModal.hide('updates-multiple-modal')
    this.$bvToast.toast('Los registros han sido actualizados correctamente', {
      title: 'Listo',
      autoHideDelay: 4000
    })
    this.searchData()
  }

  validFields () {
    for (let i = 0; i < this.fieldsListToUpdate.length; i++) {
      if (!this.fieldsListToUpdate[i].valid) {
        return false
      }
    }
    return true
  }

  /** DOWNLOAD FILES & DATA */

  openDownloadFiles () {
    if (this.validateSelection()) {
      this.$bvModal.show('download-files-modal')
    }
  }

  downloadFiles () {
    this.$bvModal.hide('download-files-modal')
    this.$bvToast.toast('La liga para descargar los archivos ha sido enviada al correo proporcionado', {
      title: 'Archivos enviados',
      autoHideDelay: 4000
    })
  }

  downloadData () {
    if (this.validateSelection()) {
      // TODO
    }
  }

  validateSelection (): boolean {
    if (this.selectedItems.length) {
      return true
    } else {
      this.$bvToast.toast('Seleccione al menos un registro', {
        title: 'Acción requerida',
        autoHideDelay: 3200
      })
      return false
    }
  }

  loadRowsWithHistory () {
    this.showHistory = !this.showHistory
    this.searchData()
  }
}
